import { AfterViewInit, Component, ElementRef, Input, ViewEncapsulation } from '@angular/core';
import { GlobalElementType } from '../../enums/global-element-type-uid.enum';
import { environment } from '../../../../environments/environment';
import { LiveChatService } from '@challenger/care/services/live-chat.service';
import { ModalService } from '../../../common/services/modal.service';

@Component({
  selector: 'vm-markdown',
  templateUrl: './markdown.component.html',
  styleUrls: ['./markdown.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MarkdownComponent implements AfterViewInit {
  @Input() data: string;
  strapiUrl = environment.strapiURL;
  globalElementType = GlobalElementType;

  constructor(private liveChatService: LiveChatService, private modalService: ModalService, private el: ElementRef) {}

  ngAfterViewInit() {
    this.initialiseLiveChatLinks();
    this.initialiseModalLinks();
  }

  public initialiseLiveChatLinks() {
    const elements = this.el.nativeElement.querySelectorAll('.angular-live-chat-bot-link');
    elements.forEach((element) => {
      const chatBotId = element.getAttribute('target');
      if (chatBotId) {
        element.addEventListener('click', this.onLiveChatLinkClick.bind(this));
        this.liveChatService.registerChatBot(chatBotId);
      }
    });
  }

  public initialiseModalLinks() {
    const elements = this.el.nativeElement.querySelectorAll('.angular-modal-link');
    elements.forEach((element) => {
      const modalId = element.getAttribute('target');
      if (modalId) {
        element.addEventListener('click', this.onModalLinkClick.bind(this));
      }
    });
  }

  public onLiveChatLinkClick(event: any) {
    const chatBotId = event?.srcElement?.attributes?.target?.value;
    this.liveChatService.showChatBot(chatBotId);
  }

  public onModalLinkClick(event: any) {
    const modalId = event?.srcElement?.attributes?.target?.value;
    this.modalService.showModal(modalId);
  }
}
